(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nux-frame-verdant-product"] && !Shopify.designMode) return;
  try {
    
  class NuxFrameVerdantCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
      this.previousButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      this.activeIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      this.pointerStartX = 0;
      this.pointerStartY = 0;
      this.pointerId = null;

      if (this.activeIndex < 0) this.activeIndex = 0;
      if (this.slides.length < 2) return;

      this.previousButton?.addEventListener('click', () => this.goTo(this.activeIndex - 1));
      this.nextButton?.addEventListener('click', () => this.goTo(this.activeIndex + 1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.carouselIndex)));
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.goTo(this.activeIndex - 1);
        if (event.key === 'ArrowRight') this.goTo(this.activeIndex + 1);
      });

      this.addEventListener('pointerdown', this.handlePointerDown.bind(this));
      this.addEventListener('pointerup', this.handlePointerUp.bind(this));
      this.addEventListener('pointercancel', this.resetPointer.bind(this));

      this.goTo(this.activeIndex);
    }

    handlePointerDown(event) {
      if (event.pointerType === 'mouse') return;

      this.pointerId = event.pointerId;
      this.pointerStartX = event.clientX;
      this.pointerStartY = event.clientY;
      this.setPointerCapture?.(event.pointerId);
    }

    handlePointerUp(event) {
      if (this.pointerId !== event.pointerId) return;

      const deltaX = event.clientX - this.pointerStartX;
      const deltaY = event.clientY - this.pointerStartY;
      const isHorizontalSwipe = Math.abs(deltaX) > 42 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25;

      if (isHorizontalSwipe) {
        this.goTo(deltaX < 0 ? this.activeIndex + 1 : this.activeIndex - 1);
      }

      this.resetPointer(event);
    }

    resetPointer(event) {
      if (event?.pointerId && this.hasPointerCapture?.(event.pointerId)) {
        this.releasePointerCapture(event.pointerId);
      }

      this.pointerId = null;
      this.pointerStartX = 0;
      this.pointerStartY = 0;
    }

    goTo(index) {
      const nextIndex = (index + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === nextIndex;
        slide.classList.toggle('is-active', isActive);
        slide.toggleAttribute('inert', !isActive);
      });

      this.dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === nextIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      this.activeIndex = nextIndex;
    }
  }

  if (!customElements.get('nux-frame-verdant-carousel')) {
    customElements.define('nux-frame-verdant-carousel', NuxFrameVerdantCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nux-launch-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = new Set();

    const pad = (value) => String(value).padStart(2, '0');

    const setText = (section, selector, value) => {
      const element = section.querySelector(selector);
      if (element) element.textContent = value;
    };

    const updateCountdown = (section) => {
      const launchDate = new Date(section.dataset.launchAt);
      const target = launchDate.getTime();

      if (Number.isNaN(target)) return;

      const remaining = Math.max(0, target - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      setText(section, '[data-countdown-days]', pad(days));
      setText(section, '[data-countdown-hours]', pad(hours));
      setText(section, '[data-countdown-minutes]', pad(minutes));
      setText(section, '[data-countdown-seconds]', pad(seconds));
    };

    const mount = (root = document) => {
      root.querySelectorAll('[data-nux-countdown-section]').forEach((section) => {
        if (section.dataset.nuxCountdownMounted === 'true') return;

        section.dataset.nuxCountdownMounted = 'true';
        sections.add(section);

        updateCountdown(section);
      });
    };

    mount();
    window.setInterval(() => sections.forEach(updateCountdown), 1000);
    document.addEventListener('shopify:section:load', (event) => mount(event.target));

    const getDialog = (trigger) => {
      const selector = trigger.getAttribute('aria-controls');
      if (!selector) return null;
      return document.getElementById(selector);
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const openTrigger = event.target.closest('[data-nux-countdown-signup-open]');
      if (openTrigger) {
        const dialog = getDialog(openTrigger);
        if (dialog instanceof HTMLDialogElement && !dialog.open) {
          dialog.showModal();
          dialog.querySelector('input[type="email"]')?.focus();
        }
      }

      const closeTrigger = event.target.closest('[data-nux-countdown-signup-close]');
      if (closeTrigger) {
        const dialog = closeTrigger.closest('[data-nux-countdown-signup-dialog]');
        if (dialog instanceof HTMLDialogElement) dialog.close();
      }

      if (event.target.matches('[data-nux-countdown-signup-dialog]')) {
        event.target.close();
      }
    });

    document.querySelectorAll('[data-nux-countdown-signup-dialog][data-open-on-load]').forEach((dialog) => {
      if (dialog instanceof HTMLDialogElement && !dialog.open) dialog.showModal();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
